export default "__VITE_ASSET__CPbfOgmb__"